/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "id-card-59e9e2ab--sprite",
  "use": "id-card-59e9e2ab--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"id-card-59e9e2ab--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><path d=\"M-173.526,26.83h-15.8a.987.987,0,0,0-.99.99V37.7a.987.987,0,0,0,.99.99h15.8a.993.993,0,0,0,.99-.99V27.82A.993.993,0,0,0-173.526,26.83ZM-184.054,33.1a2.728,2.728,0,0,1-1.935.8,2.734,2.734,0,0,1-2.732-2.737,2.725,2.725,0,0,1,.8-1.931,2.725,2.725,0,0,1,1.931-.8,2.728,2.728,0,0,1,1.935.8,2.725,2.725,0,0,1,.8,1.931A2.728,2.728,0,0,1-184.054,33.1Zm9.416,3.9h-6.468a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.468a.5.5,0,0,1,.5.5A.494.494,0,0,1-174.638,37Zm0-1.967h-6.468a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.468a.5.5,0,0,1,.5.5A.5.5,0,0,1-174.638,35.031Zm0-1.994h-6.468a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.468a.494.494,0,0,1,.5.5A.5.5,0,0,1-174.638,33.037Z\" transform=\"translate(199.474 -14.756)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
